import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

interface IRQDueRemittanceTransacitonsHeader {
	clientsDDL: any,
	accountantDDL: any,
	frequencyDDL: any,
	remittanceYearDDL: any,
	remittanceMonthDDL: any,
	onAccountantSelectionChangeHandler: (value: any) => void
	setStateRunGetListAPICall: (value: boolean) => void
}

export const RQDueRemittanceTransacitonsHeader: React.FC<
	IRQDueRemittanceTransacitonsHeader
> = ({ accountantDDL, onAccountantSelectionChangeHandler, clientsDDL, frequencyDDL, remittanceYearDDL, remittanceMonthDDL, setStateRunGetListAPICall }) => {

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"accountant"}
						items={accountantDDL ?? []}
						selectedItem={"all"}
						label={"Accountant Name"}
						testId={"cleint-ddl"}
						onSelectionChangeHandler={onAccountantSelectionChangeHandler}
					/>
				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedDropDownRHFWithLabel
						selectName={"client"}
						items={clientsDDL ?? []}
						selectedItem={"all"}
						label={"Client Name"}
						testId={"cleint-ddl"}
					/>
				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"clientType"}
						items={[
							{
								label: "All",
								value: "all",
							},
							{
								label: "Test",
								value: 200,
							},
							{
								label: "Live",
								value: 100,
							}
						]}
						label={"Client Type"}
						testId={"client-type"}
						selectedItem={"all"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
					/>


				</Grid>
				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid
					size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
				>
					<EnhancedDropDownRHFWithLabel
						selectName={"frequency"}
						items={frequencyDDL ?? []}
						label={"Frequency"}
						testId={"frequency"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						selectedItem={"all"}
					/>
				</Grid>

				<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					>
						<EnhancedDropDownRHFWithLabel
							selectName={"remittanceYear"}
							items={remittanceYearDDL ?? []}
							label={"Remittance Year"}
							testId={"remittanceYear"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							selectedItem={"all"}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
					<Grid
						size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}
					>
						<EnhancedDropDownRHFWithLabel
							selectName={"remittanceMonth"}
							items={remittanceMonthDDL ?? []}
							label={"Remittance Month"}
							testId={"remittanceMonth"}
							onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
							selectedItem={remittanceMonthDDL && remittanceMonthDDL[new Date().getMonth()].value}
						/>
					</Grid>
					<Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }}></Grid>
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 2.5, lg: 2.5, xl: 2.5 }}>
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						// onClickHandler={onApplyButtonClickedHandler}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
					// onClickHandler={() => setStateRunGetListAPICall(true)}
					/>
				</Grid>

			</Grid>


		</>
	);
};
